export default __webpack_public_path__ + "static/media/logo.f6f46747.PNG";